import { ROUTES as defaultRoutes } from '../../../default/routes.ts';

const ROUTES = {
  ...defaultRoutes,
} as const;

export { ROUTES };
